var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBjpy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1740641136009,
    className: "icon",
    viewBox: "0 0 1187 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 8183,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 231.8359375,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M532.48 399.36a30.72 30.72 0 0 1 30.43328 26.54208l0.28672 4.17792v368.64a30.72 30.72 0 0 1-61.15328 4.17792L501.76 798.72v-368.64a30.72 30.72 0 0 1 30.72-30.72z",
    fill: "#ffffff",
    "p-id": 8184
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M716.8 583.68a30.72 30.72 0 0 1 4.17792 61.15328l-4.17792 0.28672h-368.64a30.72 30.72 0 0 1-4.17792-61.15328l4.17792-0.28672h368.64z",
    fill: "#ffffff",
    "p-id": 8185
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M280.28928 235.52h534.9376l97.40288 104.69376c10.81344 11.59168 17.408 26.4192 18.88256 42.06592l0.32768 6.7584V532.48a30.72 30.72 0 0 1-61.15328 4.17792L870.4 532.48V389.03808a10.24 10.24 0 0 0-1.2288-4.9152l-1.51552-2.048L788.48 296.96H302.57152L198.2464 384.2048a10.24 10.24 0 0 0-3.44064 5.65248l-0.24576 2.21184V839.68c0 26.50112 20.15232 48.3328 45.95712 50.95424L245.76 890.88h430.08a30.72 30.72 0 0 1 4.17792 61.15328l-4.17792 0.28672H245.76a112.64 112.64 0 0 1-112.4352-105.75872L133.12 839.68V392.06912c0-18.8416 7.45472-36.864 20.52096-50.21696l5.20192-4.79232L280.28928 235.52z",
    fill: "#ffffff",
    "p-id": 8186
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M143.36 40.96m45.79328 0l686.65344 0q45.79328 0 45.79328 45.79328l0-0.04096q0 45.79328-45.79328 45.79328l-686.65344 0q-45.79328 0-45.79328-45.79328l0 0.04096q0-45.79328 45.79328-45.79328Z",
    fill: "#ffffff",
    "p-id": 8187
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M901.12 983.04a204.8 204.8 0 1 1 0-409.6 204.8 204.8 0 0 1 0 409.6z m0-51.2a153.6 153.6 0 1 0 0-307.2 153.6 153.6 0 0 0 0 307.2z",
    fill: "#ffffff",
    "p-id": 8188
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M915.12832 785.2032l56.19712 40.87808c3.93216 2.8672 6.30784 6.9632 6.5536 11.30496a14.70464 14.70464 0 0 1-5.07904 11.8784l-0.53248 0.45056a22.48704 22.48704 0 0 1-27.4432 1.26976l-57.344-41.7792c-7.24992-2.62144-11.96032-8.68352-11.96032-15.40096v-75.61216c0-9.25696 8.84736-16.75264 19.78368-16.75264s19.82464 7.49568 19.82464 16.75264v67.01056z",
    fill: "#ffffff",
    "p-id": 8189
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBjpy);
export default __webpack_public_path__ + "static/media/bjpy.2023d2ed.svg";
export { ForwardRef as ReactComponent };